export default "__VITE_ASSET__CiLSo8Bm__"